import BasicResource from '@/api/resource';

class Resource extends BasicResource {

    constructor () {
        super('analytics');
    }

    timeseries (params) {
        return this.client.request ({
            method: 'get',
            path: '/publisher/v2/analytics/timeseries',
            params,
        });
    }

    pivot (params) {
        return this.client.request ({
            method: 'get',
            path: '/publisher/v2/analytics/pivot',
            params,
        });
    }

    overview (params) {
        return this.client.request ({
            method: 'get',
            path: '/publisher/v2/analytics/overview',
            params,
        });
    }

    report (params) {
        // TODO find a way to set this up in useFilters()
        params.group_by = 'offer_id';
        return this.client.request ({
            method: 'get',
            path: '/publisher/v2/analytics/report',
            params,
        });
    }

    reportDownload (data) {
        const { sort, limit, offset, ...params } = { ...data };

        return this.client.download ({
            method: 'get',
            responseType: 'blob',
            path: '/publisher/v2/analytics/report/download',
            params,
        });
    }

    kpiList (params) {
        return this.client.request ({
            method: 'get',
            path: '/publisher/v2/analytics/dict-kpi',
            params,
        });
    }
}

export default new Resource;
